export default __webpack_public_path__ + "static/media/calendar.378031a0.png";